import { render, staticRenderFns } from "./WithDraw.vue?vue&type=template&id=3220bcfd&scoped=true&"
import script from "./WithDraw.vue?vue&type=script&lang=js&"
export * from "./WithDraw.vue?vue&type=script&lang=js&"
import style0 from "./WithDraw.vue?vue&type=style&index=0&lang=less&"
import style1 from "./WithDraw.vue?vue&type=style&index=1&id=3220bcfd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220bcfd",
  null
  
)

export default component.exports